// src/pages/categories/Categories.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CategoriesTable from "../../components/categories/CategoriesTable";

const Categories = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <CategoriesTable />
        </WrapperSection>
    );
};

export default Categories;
